module.exports = __webpack_public_path__ + "static/media/bus.0f042316.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus.svg
// module id = 424
// module chunks = 0